import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../shared/services/auth.service';
import { clearHostedLoginFragment, readHostedLoginResult } from '../../shared/utils/hostedLoginClient';

// Where api-v2's hosted SSO and MFA pages send the browser back to. On success
// it hands over to /login, which already routes a signed-in user to venue choice.
@Component({
  selector: 'app-sso-callback',
  template: `
    <div class="d-flex justify-content-center align-items-center login-page w-100 vh-100">
      <div class="login-page-wrapper">
        <p *ngIf="!error" class="text-center">Signing you in...</p>
        <ng-container *ngIf="error">
          <p class="error-message text-center">{{ error }}</p>
          <a routerLink="/login" class="d-block text-center forgot-link">Back to sign in</a>
        </ng-container>
      </div>
    </div>
  `,
  styleUrls: ['../login/login.component.scss']
})
export class SsoCallbackComponent implements OnInit {
  public error: string | null = null;

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    // The code is single-use and must not linger in history or a copied URL.
    const result = readHostedLoginResult(window.location.hash);
    clearHostedLoginFragment(window);

    if (!result) {
      this.error = 'The sign-in did not complete. Start again.';
      return;
    }
    if ('error' in result) {
      this.error = result.message;
      return;
    }
    this.authService.completeHostedLogin(result.handoffCode)
      .then(() => this.router.navigate(['/login']))
      .catch((err) => {
        this.error = err && err.userFacing ? err.message : 'Sign-in could not be completed. Try again.';
      });
  }
}
